export const ROUTES = {
  HOME: '/',
  COURSES: '/courses',
  COURSE_ABOUT: '/courses/:courseId/about',
  ABOUT: '/about',
  FAQ: '/faq',
  HELP: '/help',
  LEGAL_TERMS: '/legal/terms',
  LEGAL_PRIVACY: '/legal/privacy',
  NOT_FOUND: '*',
} as const;
